import { render, staticRenderFns } from "./SearchLenders.vue?vue&type=template&id=96ce8bce&scoped=true&"
import script from "./SearchLenders.vue?vue&type=script&lang=js&"
export * from "./SearchLenders.vue?vue&type=script&lang=js&"
import style0 from "./SearchLenders.vue?vue&type=style&index=0&id=96ce8bce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ce8bce",
  null
  
)

export default component.exports